import { IEtabAdminFolder, EtabAdminFolderModel, IIban } from "@core/models";

export const EtabAdminFolderMock = new EtabAdminFolderModel({
  [IEtabAdminFolder.socialReason]: "Big Holding",
  [IEtabAdminFolder.siret]: "012345678",
  [IEtabAdminFolder.vat]: "FR53157896342",
  [IEtabAdminFolder.id]: "1",
  [IEtabAdminFolder.address]: "10 rue du paradis",
  [IEtabAdminFolder.city]: "Paris",
  [IEtabAdminFolder.country]: "France",
  [IEtabAdminFolder.email]: "bigmama@gmail.com",
  [IEtabAdminFolder.etabName]: "Big Mama",
  [IEtabAdminFolder.postalCode]: "75000",
  [IEtabAdminFolder.hasAdminInfo]: true,
  [IEtabAdminFolder.hasCard]: true,
  [IEtabAdminFolder.cardsCount]: 2,
  [IEtabAdminFolder.registeredIban]: true,
  [IEtabAdminFolder.ibanDetails]: {
    [IIban.owner]: "Jean Bernard",
    [IIban.ibanLastDigits]: "1234",
  },
  [IEtabAdminFolder.paymentMean]: "sepa_debit",
});
